import React, { useEffect, useContext, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Panel from 'components/common/panel/panel';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import SiteContext from 'components/shared/siteContext/siteContext';
import './menusCellDetailsPage.css';

export default function MenusCellDetailsPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const id = props.match.params.id;
  const cellId = id % 100;
  const screenId = (id - cellId) / 100;

  const [selectedColor, setSelectedColor] = useState(1);

  useEffect(() => {
    setAppArea(AppContext.Areas.Menus, 'Edit Cell');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Menus', href: '/Menus' }, { name: `Screen #${screenId}`, href: `/Menus/Screen/${screenId}` }, { name: `Cell #${cellId}`, selected: true }]);
  }, []);

  const handleCancelClicked = () => {
    props.history.goBack();
  };

  const handleSaveClicked = () => {
    props.history.push(`/Menus/Screen/${screenId}`);
  };

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button hierarchyId={141} readOnly />
          <div className='flex-grow-1 d-flex justify-content-end'>
            <Inputs.Button variant='default' onClick={handleCancelClicked} iconClass='icons8-undo' label='Cancel' />
            <Inputs.Button variant='success' onClick={handleSaveClicked} iconClass='icons8-save' label='Save' />
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Form>
              <Panel>
                <Panel.Header>
                  Cell Details
              </Panel.Header>
                <Panel.Body>
                  <Form.Group>
                    <Form.Label required>Cell Active</Form.Label>
                    <div className='mx-2 mb-2 mt-1'>
                      <Inputs.Checkbox label='Active' checked />
                    </div>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label required>Cell Name</Form.Label>
                    <Inputs.Text placeholder='Cell Name' required />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label required>Cell Color</Form.Label>
                    <div className='mx-2 mb-2 mt-1'>
                      <div className='mb-2' style={{ color: colors[selectedColor].color }}>
                        {colors[selectedColor].name}
                      </div>
                      <div className='color-picker'>
                        {colors.map((c, i) => <div className={selectedColor === i ? 'selected' : ''} style={{ backgroundColor: c.color }} onClick={() => setSelectedColor(i)}></div>)}
                      </div>
                    </div>
                  </Form.Group>
                </Panel.Body>
              </Panel>

              <Panel>
                <Panel.Header>
                  Prices
              </Panel.Header>
                <Panel.Body>
                  <Form.Row>
                    {[...Array(10)].map((n, i) => <PriceInput number={i + 1} />)}
                  </Form.Row>
                </Panel.Body>
              </Panel>

              <div className='mb-4'>
                <Inputs.Button variant='default' onClick={handleCancelClicked} iconClass='icons8-undo' label='Cancel' />
                <Inputs.Button variant='success' onClick={handleSaveClicked} iconClass='icons8-save' label='Save' />
              </div>

            </Form>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function PriceInput(props) {
  return (
    <Form.Group className='col-4'>
      <Form.Label>Price {props.number}</Form.Label>
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>$</InputGroup.Text>
        </InputGroup.Prepend>
        <Inputs.Float placeholder='0.00' precision='2' />
      </InputGroup>
    </Form.Group>
  );
}

const colors = [
  {
    name: 'Light Cyan',
    color: '#49A3A4',
  },
  {
    name: 'Magenta',
    color: '#871970',
  },
  {
    name: 'Blue',
    color: '#253950',
  },
  {
    name: 'Black',
    color: '#313131',
  },
  {
    name: 'Yellow',
    color: '#CFA745',
  },
  {
    name: 'Red',
    color: '#902D3B',
  },
  {
    name: 'Green',
    color: '#3B6946',
  },
  {
    name: 'Light Blue',
    color: '#2D69A0',
  },
  {
    name: 'Brown',
    color: '#B85A27',
  },
  {
    name: 'Light Red',
    color: '#EA3732',
  },
];